<template>
  <div>
    <el-row type="flex" justify="space-between">
      <el-col @click.native="() => getId()" :span="2" style="cursor: pointer">
        <el-card class="box-card order-display-card card-calendar" shadow="never">
          <div slot="header" class="title-card-header">
            <el-date-picker
              v-model="date"
              type="date"
              @change="orderDisplayFilterKey = orderDisplayFilterKey"
              placeholder="Pick a day"
              class="custom-date-order"
              id="pickerDate"
              :clearable="false"
            ></el-date-picker>
          </div>
          <div class="content-card-calendar">{{ date | dateAndMonth }}</div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card
          @click.native="onClickCard('tab1'); orderDisplayFilterKey = 'All'"
          class="box-card order-display-card"
          :class="[tabs.tab1 ? 'activeClass' : '']"
          shadow="never"
        >
          <div slot="header" class="title-card-header">
            <span>Semua Order</span>
          </div>
          <div class="content-card-header">40</div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card
          @click.native="onClickCard('tab2'); orderDisplayFilterKey = 'Dalam Proses'"
          class="box-card order-display-card"
          shadow="never"
          :class="[tabs.tab2 ? 'activeClass' : '']"
        >
          <div slot="header" class="title-card-header">
            <span>Dalam Proses</span>
          </div>
          <div class="content-card-header">
            <i class="el-icon-shopping-cart-2"></i>
            10
          </div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card
          @click.native="onClickCard('tab3'); orderDisplayFilterKey = 'Warehouse'"
          class="box-card order-display-card"
          shadow="never"
          style="cursor: pointer"
          :class="[tabs.tab3 ? 'activeClass' : '']"
        >
          <div slot="header" class="title-card-header">
            <span>Warehouse</span>
          </div>
          <div class="content-card-header">
            <i class="el-icon-box"></i>
            3
          </div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card
          @click.native="onClickCard('tab4'); orderDisplayFilterKey = 'Pengiriman'"
          class="box-card order-display-card"
          shadow="never"
          style="cursor: pointer"
          :class="[tabs.tab4 ? 'activeClass' : '']"
        >
          <div slot="header" class="title-card-header">
            <span>Pengiriman</span>
          </div>
          <div class="content-card-header">
            <i class="el-icon-truck"></i>
            10
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-card shadow="never" class="mt-4 content-head" dark>
        <el-row type="flex" justify="space-between">
          <p class="left">{{ orderDisplayFilterKey }}</p>
          <p class="right">{{ date | dateMonthYear }}</p>
        </el-row>
      </el-card>
    </el-row>
    <el-row type="flex" :gutter="20" style="flex-wrap: wrap">
      <el-row type="flex" justify="center" class="mt-3" style="width: 100%">
        <h2 v-if="orderDisplayFilter.length === 0">Tidak ada data</h2>
      </el-row>
      <el-col style="width: 250px" v-for="(item,index) in orderDisplayFilter" :key="index">
        <el-card shadow="never" class="mt-4 custom-order-item" :class="[colorTime(item.time)]">
          <div slot="header" class="clearfix">
            <span>{{ time(item.time).format("DDD HH:mm:ss") }}</span>
          </div>
          <div class="text item section-1">
            <qr-code :text="item.qr_code" :size="100"></qr-code>
          </div>
          <el-divider></el-divider>
          <div class="text item section-2">
            <p class="id">{{ item.qr_code }}</p>
            <p class="time">{{ item.date_time | dateTime }}</p>
          </div>
          <el-divider></el-divider>
          <div class="text item section-3">
            <p class="store-name">{{ item.store_name }}</p>
            <p class="name">{{ item.name }}</p>
            <p class="truncate-total">
              Net Price :
              <span class="total">Rp {{ formatPrice(item.total) }}</span>
            </p><!--Total:-->
          </div>
          <div
            v-if="item.payment_method == 'Menunggu Pembayaran'"
            class="text item section-4 bg-warning"
          >{{ item.payment_method }}</div>
          <div
            v-if="item.payment_method == 'Dalam Proses'"
            class="text item section-4 bg-warning"
          >{{ item.payment_method }}</div>
          <div
            v-else-if="item.payment_method == 'Pengiriman'"
            class="text item section-4 bg-primary"
          >{{ item.payment_method }}</div>
          <div
            v-else-if="item.payment_method == 'Selesai'"
            class="text item section-4 bg-success"
          >{{ item.payment_method }}</div>
          <div
            v-else-if="item.payment_method == 'Cancelled'"
            class="text item section-4 bg-danger"
          >{{ item.payment_method }}</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
import { formatPrice } from "../../common/formatPrice";
import { mapActions, mapState } from "vuex";
export default {
  data: function() {
    return {
      tabs: {
        tab1: true,
        tab2: false,
        tab3: false,
        tab4: false
      },
      orderDisplayFilterKey: "All",
      date: new Date(),
      countUp: moment().format()
    };
  },
  methods: {
    /**
     * untuk tabs
     */
    onClickCard: function(params) {
      this.tabs = {
        tab1: false,
        tab2: false,
        tab3: false,
        tab4: false,
        [params]: true
      };
    },
    /**
     * format Price ada di helper
     */
    formatPrice: function(params) {
      return formatPrice(params);
    },
    getId: function() {
      let id = document.getElementById("pickerDate");
      id.focus();
    },
    ...mapActions({
      getOrderDisplays: "orderdisplay/GetOrderDisplays"
    })
  },
  computed: {
    ...mapState({
      orderdisplay: state => state.orderdisplay
    }),
    /**
     *  untuk filter per payment method and date
     */
    orderDisplayFilter() {
      return this.orderdisplay.orderDisplays.filter(item => {
        const date = moment(item.date_time)
          .subtract(7, "h")
          .format("DD/MM/YYYY");
        const dateFromUser = moment(this.date).format("DD/MM/YYYY");
        if (this.orderDisplayFilterKey == "All") {
          return item && dateFromUser == date;
        }
        return (
          item.payment_method == this.orderDisplayFilterKey &&
          dateFromUser == date
        );
      });
    },
    /**
     * format time countUp bisa di baca di dokementasi moment.js
     */
    time: function() {
      return datetime => {
        var diff = moment.duration(moment(this.countUp).diff(moment(datetime)));
        let formatedDiff = moment.utc(diff.asMilliseconds());
        return formatedDiff;
      };
    },
    /**
     * kondisi waktu apakah bewarna kuning atau merah
     */
    colorTime: function() {
      return datetime => {
        var diff = moment.duration(moment(this.countUp).diff(moment(datetime)));
        let color = "";
        if (diff.asHours() >= 24) {
          color = "bg-danger";
        } else if (diff.asHours() >= 8) {
          color = "bg-warning";
        }
        return color;
      };
    }
  },
  filters: {
    /**
     * format datetime bisa di baca di dokementasi moment.js
     */
    dateTime: function(datetime) {
      moment(datetime).format("DD/MM/YYYY - hh:mm:ss");
    },
    /**
     * format date and month bisa di baca di dokementasi moment.js
     */
    dateAndMonth: function(datetime) {
      return moment(datetime).format("DD MMM");
    },
    /**
     * format date, month and year bisa di baca di dokementasi moment.js
     */
    dateMonthYear: function(datetime) {
      return moment(datetime).format("DD MMM YYYY");
    }
  },
  mounted: function() {
    setInterval(() => {
      this.countUp = moment(this.countUp).add(1, "second");
    }, 1000);
  },
  created() {
    let option = {
      params: {}
    };
    this.getOrderDisplays(option);
  }
};
</script>

<style>
.order-display-card {
  cursor: pointer;
}
.order-display-card.activeClass {
  border: 1px solid #32c5ff !important;
}
.title-card-header {
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #15216a;
}
.content-card-header {
  font-size: 48px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #15216a;
}
.content-card-calendar {
  font-size: 30px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #15216a;
}
.custom-date-order {
  width: 65% !important;
  cursor: pointer;
}
.custom-date-order > .el-input__inner {
  width: 0px;
  padding: 0px !important;
  border: none;
}
.custom-date-order > .el-input__prefix > .el-input__icon {
  font-size: 25px !important;
  color: #15216a;
}
.content-head {
  background-color: #15216a !important;
}
.content-head > div > div > .left,
.content-head > div > div > .right {
  font-size: 32px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0;
}
.custom-order-item.bg-warning > .el-card__header {
  background-color: #fa6000;
}
.custom-order-item.bg-danger > .el-card__header {
  background-color: #e02020;
}
.custom-order-item > .el-card__header {
  background-color: #00b51e;
  border-radius: 5px;
  padding: 10px 20px !important;
  font-size: 23px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.custom-order-item > .el-card__body {
  padding: 20px 0px 0px 0px;
}
.custom-order-item > div > .el-divider--horizontal {
  margin: 10px 0px !important;
}
.section-1,
.section-2,
.section-3,
.section-4 {
  padding: 0px 20px;
}
.section-1 {
  text-align: center;
}
.section-1 > div > img {
  margin: auto;
}
.section-2 > .id {
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin: 0;
}
.section-2 > .time {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin: 0;
}
.section-3 {
  text-align: center;
}
.section-3 > .store-name {
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #15216a;
  margin: 0px;
}
.section-3 > .name {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.section-3 > p > .total {
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000000;
}
.section-4 {
  border-radius: 5px;
  color: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}
.card-calendar > .el-card__header {
  padding: 7px 20px;
}
.card-calendar > .el-card__body {
  padding: 9px 20px;
}
.truncate-total {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>